export default __webpack_public_path__ + "static/media/banner.b61e612e.png";